import { useState, useEffect, useCallback } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { formatDate } from "../../helpers/transformDate";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import axios from "axios";
import { Base_URL } from "../../helpers/constants";
import useAuth from "../../hooks/useAuth";

function SingleReviewList() {
  const params = useParams();
  const navigation = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const id = params.id;
  const [reviews, setReviews] = useState(null);
  const [loading, setLoading] = useState(false);
  const [notifyOwner, setNotifyOwner] = useState(false);
  const { auth } = useAuth();

  const token = auth.accessToken;

  let payload = {
    id,
    notifyOwner,
  };

  const fetchReviewData = useCallback(async () => {
    try {
      const response = await axiosPrivate.get(`reviews/id=${id}`);
      setReviews(response.data);
      setLoading(true);
    } catch (err) {
      console.error(err);
    }
  }, [axiosPrivate, id]);

  const handleApproveAndNext = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    try {
      await axios({
        method: "POST",
        url: `${Base_URL}confirmReview`,
        data: payload,
        headers: { Authorization: `Bearer ${token}` },
      });

      const nextReviewResponse = await axiosPrivate.get(
        `reviews/nextNewReview`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (nextReviewResponse.data) {
        setNotifyOwner(false);
        navigation(`/reviews/${nextReviewResponse.data.id}`);
      } else {
        setNotifyOwner(false);
        alert("Ni več nepotrjenih ocen");
        navigation(-1); // Go back if no new reviews are available
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleApprove = (e) => {
    e.stopPropagation();
    e.preventDefault();

    axios({
      method: "POST",
      url: `${Base_URL}confirmReview`,
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(function (res) {
        alert("Successfully approved!");
        fetchReviewData();
      })
      .catch(function (res) {
        console.log(res);
      });
  };

  const handleReject = (e) => {
    e.stopPropagation();
    e.preventDefault();

    axios({
      method: "POST",
      url: `${Base_URL}declineReview`,
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(function (res) {
        alert("Successfully declined!");
        fetchReviewData();
      })
      .catch(function (res) {
        console.log(res);
      });
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    e.preventDefault();

    axios({
      method: "POST",
      url: `${Base_URL}deleteReview`,
      data: payload,
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(function (res) {
        alert("Successfully declined!");
        fetchReviewData();
      })
      .catch(function (res) {
        console.log(res);
      });
  };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getSingleReview = async () => {
      try {
        const response = await axiosPrivate.get(`reviews/id=${id}`, {
          signal: controller.signal,
        });
        if (isMounted) {
          setReviews(response.data);
          setLoading(true);
        }
      } catch (err) {
        console.error(err);
      }
    };

    getSingleReview();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [id]);

  const displayReviews = (reviews) => {
    if (!reviews) return null;

    return reviews.map((review, index) => {
      let compLink = `${process.env.REACT_APP_ADMIN_HOST}/${review.re_vendor_id}/reviews`;

      return (
        <div className="container prcReviewSingle" key={index}>
          <div className="row">
            <div className="col-md-12">
              {review.re_status === "NEW" && (
                <div>
                  <div className="row prcReviewSingleElement">
                    <div className="col-md-12">
                      <Button
                        variant="secondary"
                        className="mx-2 mb-2"
                        onClick={() => navigation(-1)}
                      >
                        Nazaj
                      </Button>
                      <div className="prcReviewSingleElementBtnRight float-md-end text-md-end">
                        <Button
                          className="mx-2 mb-2"
                          variant="danger"
                          onClick={handleReject}
                        >
                          Zavrni
                        </Button>
                        <Button
                          className="mx-2 mb-2"
                          variant="success"
                          onClick={handleApprove}
                        >
                          Potrdi
                        </Button>
                        <Button
                          className="mx-2 mb-2"
                          variant="success"
                          onClick={handleApproveAndNext}
                        >
                          Potrdi in naprej
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="row prcReviewSingleElement">
                      <div className="offset-md-6 col-md-6">
                        <div className="prcReviewSingleElementCheckbox mt-2 text-md-end">
                          <input
                            id="prcReviewSingleElementId"
                            type="checkbox"
                            checked={notifyOwner}
                            onChange={(e) => setNotifyOwner(e.target.checked)}
                          />
                          &nbsp;
                          <label htmlFor="prcReviewSingleElementId">
                            O oceni obvesti skrbnika
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {review.re_status === "APPROVED" && (
                <div className="row">
                  <div className="col-md-12">
                    <Button variant="secondary" className="mx-2 mb-2">
                      Nazaj
                    </Button>
                  </div>
                </div>
              )}

              <hr />

              <div className="row prcReviewSingleElement">
                <div className="col-md-6">
                  <strong>Status</strong>
                </div>
                <div className="col-md-6">{review.re_status}</div>
              </div>

              <div className="row prcReviewSingleElement">
                <div className="col-md-6">
                  <strong>Servis</strong>
                </div>
                <div className="col-md-6">{review.co_origin}</div>
              </div>

              {review.co_origin === "FEEDBACK" && (
                <div className="row prcReviewSingleElement">
                  <div className="col-md-6">
                    <strong>Podjetje</strong>
                  </div>
                  <div className="col-md-6">
                    <a
                      href={compLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {review.co_name}
                    </a>
                  </div>
                </div>
              )}

              {review.product_group && (
                <div className="row prcReviewSingleElement">
                  <div className="col-md-6">
                    <strong>Grupa/Modul</strong>
                  </div>
                  <div className="col-md-6">{review.product_group}</div>
                </div>
              )}
              {review.product_name && (
                <div className="row prcReviewSingleElement">
                  <div className="col-md-6">
                    <strong>Produkt</strong>
                  </div>
                  <div className="col-md-6">
                    {review.product_name["SL"] ||
                      review.product_name["EN"] ||
                      review.product_name["HR"] ||
                      review.product_name["SR"] ||
                      review.product_name["DE"]}
                  </div>
                </div>
              )}

              <div className="row prcReviewSingleElement">
                <div className="col-md-6">
                  <strong>Ocena</strong>
                </div>
                <div className="col-md-6">{review.re_score}</div>
              </div>
              <div className="prcReviewSingleElementWrap">
                <div className="row prcReviewSingleElement">
                  {review.re_answers && (
                    <div className="col-md-6">
                      <strong>Ostali odgovori</strong>
                    </div>
                  )}
                  {review.re_answers && review.re_answers.length === 0 && (
                    <div className="col-md-6">Ni odgovorov</div>
                  )}
                </div>

                {Array.isArray(review.re_answers) &&
                  review.re_answers.length > 0 && (
                    <div>
                      {review.re_answers.map((answer, index) => {
                        return (
                          <div key={index} className="row">
                            <div className="col-md-6">
                              {answer.questionText["SL"] ||
                                answer.questionText["EN"] ||
                                answer.questionText["HR"] ||
                                answer.questionText["SR"] ||
                                answer.questionText["DE"]}
                            </div>
                            <div className="col-md-6">
                              {answer.answer.value}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
              </div>

              <div className="row prcReviewSingleElement">
                <div className="col-md-6">
                  <strong>Tekst</strong>
                </div>
                <div className="col-md-6">
                  {review.re_text && <div>{review.re_text}</div>}
                  {(!review.re_text || review.re_text.size === 0) && (
                    <div>/</div>
                  )}
                </div>
              </div>

              <div className="row prcReviewSingleElement prcReviewSingleImage">
                <div className="col-md-6">
                  <strong>Slike</strong>
                </div>
                <div className="col-md-6">
                  {review.re_images ? (
                    review.re_images.length > 0 ? (
                      review.re_images.map((image, index) => {
                        return (
                          <img
                            alt={"review"}
                            key={index}
                            src={
                              process.env.REACT_APP_SUPERADMIN_IMAGES_HOST +
                              image
                            }
                          />
                        );
                      })
                    ) : (
                      <div>/</div>
                    )
                  ) : (
                    <div>/</div>
                  )}
                </div>
              </div>

              <hr />

              <div className="row prcReviewSingleElement">
                <div className="col-md-6">
                  <strong>IP naslov</strong>
                </div>
                <div className="col-md-6">{review.re_ipaddress}</div>
              </div>

              <div className="row prcReviewSingleElement">
                <div className="col-md-6">
                  <strong>Ocena oddana</strong>
                </div>
                <div className="col-md-6">
                  <time dateTime="DD.MM.YYYY, hh:mm">
                    {formatDate(review.re_created)}
                  </time>
                </div>
              </div>
              <div className="prcReviewSingleElementWrap">
                <div className="row prcReviewSingleElement">
                  <div className="col-md-6">
                    <strong>Uporabnik</strong>
                  </div>
                </div>

                <div className="row prcReviewSingleElement">
                  <div className="col-md-6">Ime</div>
                  <div className="col-md-6">
                    {review.user_name ? review.user_name : "Anonimnež"}
                  </div>
                </div>

                <div className="row prcReviewSingleElement">
                  <div className="col-md-6">Uporabnik ustvarjen</div>
                  <div className="col-md-6">
                    <time dateTime="DD.MM.YYYY, hh:mm">
                      {formatDate(review.user_created)}
                    </time>
                  </div>
                </div>
              </div>
              <hr />

              {review.re_status === "NEW" && (
                <div>
                  {review.co_origin === "FEEDBACK" && (
                    <div className="row prcReviewSingleElement">
                      <div className="offset-md-6 col-md-6">
                        <div className="prcReviewSingleElementCheckbox text-md-end">
                          <input
                            id="prcReviewSingleElementId"
                            type="checkbox"
                            checked={notifyOwner}
                            onChange={(e) => setNotifyOwner(e.target.checked)}
                          />
                          &nbsp;
                          <label htmlFor="prcReviewSingleElementId">
                            O oceni obvesti skrbnika
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row prcReviewSingleElement">
                    <div className="col-md-12">
                      <Button
                        variant="secondary"
                        className="mx-2 mb-2"
                        onClick={() => navigation(-1)}
                      >
                        Nazaj
                      </Button>
                      <div className="prcReviewSingleElementBtnRight float-md-end text-md-end">
                        <Button
                          key={7}
                          className="mx-2 mb-2"
                          variant="danger"
                          onClick={handleReject}
                        >
                          Zavrni
                        </Button>
                        <Button
                          key={8}
                          className="mx-2 mb-2"
                          variant="success"
                          onClick={handleApprove}
                        >
                          Potrdi
                        </Button>
                        <Button
                          key={8}
                          className="mx-2 mb-2"
                          variant="success"
                          onClick={handleApproveAndNext}
                        >
                          Potrdi in naprej
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {review.re_status === "APPROVED" && (
                <div>
                  <div className="row">
                    <div className="col-md-12">
                      <Button
                        variant="secondary"
                        className="mx-2 mb-2"
                        onClick={() => navigation(-1)}
                      >
                        Nazaj
                      </Button>
                      <div className="prcReviewSingleElementBtnRight float-md-end text-md-end">
                        {review.co_origin === "FEEDBACK" && (
                          <div className="inline">
                            <Button
                              key={10}
                              variant="success"
                              className="mx-2 mb-2"
                            >
                              Obvesti skrbnika
                            </Button>
                            <Button
                              key={11}
                              variant="danger"
                              className="mb-2"
                              onClick={handleDelete}
                            >
                              Izbriši
                            </Button>
                          </div>
                        )}
                        {review.co_origin !== "FEEDBACK" && (
                          <Button
                            key={12}
                            variant="danger"
                            className="mb-2"
                            onClick={handleDelete}
                          >
                            Izbriši
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="prcContentWrap">
      {loading ? (
        displayReviews(reviews)
      ) : (
        <div
          className="d-flex justify-content-center"
          style={{ position: "absolute", top: "50%", left: "50%" }}
        >
          <div className="align-content-stretch">
            <Spinner animation="border" role="status" variant="primary" />
          </div>
        </div>
      )}
    </div>
  );
}

export default SingleReviewList;
